
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class GameBMainCharacter extends PIXI.Container {

  constructor(game) {
    super();

    let person = new PIXI.Sprite(game.assets["main-character"]);
    this.addChild(person);

  }

}
